import get from 'lodash/get';

export const getIsConfirmingInstantCheckout = state =>
  get(state, 'instantCheckout.confirming') ?? false;

export const getIsInstantCheckoutIsInProgress = state =>
  get(state, 'instantCheckout.inProgress') ?? false;
